/** Discoverability only: never use this to bypass server-side authorization. */
export function shouldShowLocalDevelopmentPreview(dev: boolean, hostname: string): boolean {
  if (!dev) return false;
  hostname = hostname.toLowerCase();
  return hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".localhost");
}

export function isLocalDevelopmentPreview(): boolean {
  return typeof window !== "undefined" &&
    shouldShowLocalDevelopmentPreview(import.meta.env.DEV, window.location.hostname);
}
